import React, { Component } from "react";
import { Form as BootstrapForm } from "react-bootstrap";
import { Formik, Field as FormikField } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
import DatePickerField from "components/layout/form/DatePickerField"

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Content,
  Separator,
  PeriodContainer,
  PeriodItem,
  PeriodCircle,
  PeriodText,
  Label,
  DateContainer,
  DateItem,
  StatusContainer,
  FilterButtonContainer,
  FilterButtonText,
  StatusRadial,
  StatusText,
  CancelButtonContainer,
  CalendarIcon,
  StatusItem
} from "./styles";

class ModalFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      beginDate: "",
      endDate: "",
      status: "Todos",
      selectedPeriod: "",
      selectedPeriodo: null,
      disabledDateField: false,
      dateError: false
    };
  }

  async componentDidMount() {
    const { status: statusState } = this.state;
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let status = await params.get("status") || statusState;
    const selectedPeriod = params.get("selected-period");
    if (status) this.setState({ status });
    if (selectedPeriod) this.setState({ selectedPeriod });

    switch (selectedPeriod) {
      case "old90days":
        this.handlePeriodo(90);
        break;
      case "old60days":
        this.handlePeriodo(60);
        break;
      case "old30days":
        this.handlePeriodo(30);
        break;
      case "old15days":
        this.handlePeriodo(15);
        break;
      default:
        break;
    }
  }

  handlePeriodo = dias => {
    const { selectedPeriodo, status } = this.state;
    let beginDate = new Date();
    let endDate = new Date();

    beginDate.setDate(beginDate.getDate() - dias);

    if (selectedPeriodo === dias) {
      this.setState({ selectedPeriodo: null, beginDate: null, endDate: null, selectedPeriod: "" });
    }
    if (selectedPeriodo != dias) {
      this.setState({ selectedPeriodo: dias });
      this.setState({ beginDate, endDate });

      switch (dias) {
        case 90:
          this.setState({ selectedPeriod: "old90days" });
          break;
        case 60:
          this.setState({ selectedPeriod: "old60days" });
          break;
        case 30:
          this.setState({ selectedPeriod: "old30days" });
          break;
        case 15:
          this.setState({ selectedPeriod: "old15days" });
          break;
        default:
          break;
      }
    }
  };

  handleSubmit = () => {
    let { beginDate, endDate, status, selectedPeriod } = this.state;
    let erroBeginDate = false;
    let erroEndDate = false;
    if (beginDate && endDate != "") {
      beginDate = moment(beginDate).format("DD-MM-YYYY");
      endDate = moment(endDate).format("DD-MM-YYYY");
    }

    if (beginDate) {
      if (beginDate.length === 10) {
        const beginDay = beginDate.substring(0, 2);
        const beginMonth = beginDate.substring(3, 5);
        const beginYear = beginDate.substring(6, 10);
        beginDate = beginYear + "-" + beginMonth + "-" + beginDay;
        erroBeginDate = false;
      } else if (beginDate.length >= 11) {
        erroBeginDate = true;
        toast.error("Informe uma data inicial válida");
      }
    }

    if (endDate) {
      if (endDate.length === 10) {
        const endDay = endDate.substring(0, 2);
        const endMonth = endDate.substring(3, 5);
        const endYear = endDate.substring(6, 10);
        endDate = endYear + "-" + endMonth + "-" + endDay;
        erroEndDate = false;
      } else if (endDate.length >= 11) {
        erroEndDate = true;
        toast.error("Informe uma data final válida");
      }
    }

    if (beginDate && !endDate) toast.error("Data final é obrigatória!");
    if (!beginDate && endDate) toast.error("Data inicial é obrigatória!");

    if (!erroBeginDate && !erroEndDate) {
      // Verifica se só data
      if (beginDate && endDate != "")
        window.location = `/consulta-debitos?begin-date=${beginDate}&end-date=${endDate}&status=${status}&selected-period=${selectedPeriod}`;

      if (!beginDate && !endDate)
        window.location = `/consulta-debitos?&status=${status}`;
    }
  };

  render() {
    const { close } = this.props;
    const FilterSchema = Yup.object().shape({});
    const { beginDate, endDate, status, selectedPeriodo } = this.state;
    return (
      <Container>
        <Header>
          <Left>
            <Title>Filtrar</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <Label>Período</Label>
          <PeriodContainer>
            <PeriodItem
              selected={selectedPeriodo === 15}
              onClick={() => this.handlePeriodo(15)}
            >
              <PeriodCircle selected={selectedPeriodo === 15} />
              <PeriodText>Últimos 15 dias</PeriodText>
            </PeriodItem>
            <PeriodItem
              selected={selectedPeriodo === 30}
              onClick={() => this.handlePeriodo(30)}
            >
              <PeriodCircle selected={selectedPeriodo === 30} />
              <PeriodText>Últimos 30 dias</PeriodText>
            </PeriodItem>
            <PeriodItem
              selected={selectedPeriodo === 60}
              onClick={() => this.handlePeriodo(60)}
            >
              <PeriodCircle selected={selectedPeriodo === 60} />
              <PeriodText>Últimos 60 dias</PeriodText>
            </PeriodItem>
            <PeriodItem
              selected={selectedPeriodo === 90}
              onClick={() => this.handlePeriodo(90)}
            >
              <PeriodCircle selected={selectedPeriodo === 90} />
              <PeriodText>Últimos 90 dias</PeriodText>
            </PeriodItem>
          </PeriodContainer>
          <Separator />
          <Label>Vencimento</Label>
          <Formik
            validationSchema={FilterSchema}
            render={() => (
              <DateContainer>
                <DateItem>
                  <BootstrapForm.Group controlId="beginDate">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <>
                            <Label>Data Inicial</Label>
                            <DatePickerField
                              onChange={date =>
                                this.setState({
                                  beginDate: date,
                                  selectedPeriodo: null
                                })
                              }
                              selected={beginDate}
                              TrailingIcon={() => <CalendarIcon className="mdi mdi-calendar-blank-outline" />}
                              styles={{ container: { width: "100%", height: "40px" } }}
                              placeholderText={"--/--/----"}
                            />
                          </>
                        );
                      }}
                      name="beginDate"
                    />
                  </BootstrapForm.Group>
                </DateItem>
                <DateItem>
                  <BootstrapForm.Group controlId="endDate">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <>
                            <Label>Data Final</Label>
                            <DatePickerField
                              onChange={date =>
                                this.setState({
                                  endDate: date,
                                  selectedPeriodo: null
                                })
                              }
                              selected={endDate}
                              disabled={beginDate === "" ? true : false}
                              minDate={new Date(beginDate)}
                              TrailingIcon={() => <CalendarIcon className="mdi mdi-calendar-blank-outline" />}
                              styles={{ container: { width: "100%", height: "40px", '&:hover': { cursor: 'pointer' } } }}
                              placeholderText={"--/--/----"}

                            />
                          </>
                        );
                      }}
                      name="endDate"
                    />
                  </BootstrapForm.Group>
                </DateItem>
              </DateContainer>
            )}
          />
          <Separator />
          <Label>Situação</Label>
          <StatusContainer>
            <StatusItem
              onClick={() => this.setState({ status: "TODOS" })}
            >
              <input
                id="Todos"
                name="Todos"
                type="radio"
                checked={status.toLocaleLowerCase() === "todos" ? true : false}
                style={{ cursor: 'pointer' }}
              />
              <StatusText >
                Todos
              </StatusText>
            </StatusItem>
            <StatusItem
              onClick={() => this.setState({ status: "VENCIDO" })}
            >
              <input
                tid="Vencido"
                name="Vencido"
                type="radio"
                checked={status === "VENCIDO" ? true : false}
                style={{ cursor: 'pointer' }}
              />
              <StatusText>
                Vencido
              </StatusText>
            </StatusItem>
            <StatusItem
              onClick={() => this.setState({ status: "PAGO" })}
            >
              <input
                id="Pago"
                name="Pago"
                type="radio"
                checked={status === "PAGO" ? true : false}
                style={{ cursor: 'pointer' }}
              />
              <StatusText>
                Pago
              </StatusText>
            </StatusItem>          
          </StatusContainer>
          <Separator />
          <DateContainer>
            <CancelButtonContainer
              onClick={close}
            >
              <FilterButtonText>Cancelar</FilterButtonText>
            </CancelButtonContainer>
            <FilterButtonContainer
              onClick={() => this.handleSubmit()}
              type="submit"
            >
              <FilterButtonText>Filtrar</FilterButtonText>
            </FilterButtonContainer>
          </DateContainer>
        </Content>
      </Container >
    );
  }
}

export default ModalFilter;
